export default function usePlural(number, single, plural) {
    if (number && parseInt(number) > 1) {
        return plural
    } else if (number && parseInt(number) < 2) {
        return single
    } else {
        return single
    }
}
